import React from 'react';
import styled from 'styled-components';

import Button from '../Button';
import Icon from '../Icon';

function Modal({large, tabs, title, header, onClose, children, options, footer}) {
  return (
    <Container large={large}>
      <Header hasTabs={!!tabs}>
        <HeaderTitle>
          <Title>{title}</Title>
          <CloseButton onClick={onClose}><Icon name="close" size="2em" /></CloseButton>
        </HeaderTitle>
        {header && (
          <HeaderContent>
            {header}
          </HeaderContent>
        )}
      </Header>
      {tabs}
      <Content>
        {typeof children === 'function' 
          ? children()
          : children}
      </Content>
      {footer}
      {options && (
        <Footer>
          {options.filter(Boolean).map((child, i) => (
            <FooterChild key={i}>{child}</FooterChild>
          ))}
        </Footer>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.large ? '80vw' : '30rem'};
  background: #f5f5f5;
  overflow: hidden;
  box-shadow: -0.625rem 0 1.25rem rgba(0, 0, 0, 0.1), -0.3125rem 0 0.625rem rgba(0, 0, 0, 0.15);
  height: 100%;

  @media (max-width: 37rem) {
    width: 100vw;
  }
`;

const Header = styled.div`
  border-bottom: ${props => props.hasTabs ? '0' : '0.0625rem solid #e4e4e4'};
`;

const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
`;

const HeaderContent = styled.div`
  padding: 0 1.875rem 1.25rem 1.875rem;
`;

const Title = styled.h2`
  font-size: 2.25rem;
  padding: 1.25rem 0 1.25rem 1.875rem;
  font-weight: 300;
  margin: 0;
  flex: 1;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 37rem) {
    font-size: 2rem;
    padding-left: 1.25rem;
  }
`;

const CloseButton = styled(props => <Button blank {...props} />)`
  padding: 0 1.875rem;

  @media (max-width: 37rem) {
    padding: 0 1.25rem;
  }
`;

const Content = styled.div`
  flex: 1;
  overflow: auto;
`;

const Footer = styled.div`
  border-top: 0.0625rem solid #e4e4e4;
  display: flex;
  flex-direction: row;
  padding-left: 1.875rem;

  @media (max-width: 37rem) {
    padding-left: 1.25rem;
  }
`;

const FooterChild = styled.div`
  padding: 1.25rem 0 1.25rem 0.625rem;
  display: flex;
  align-items: center;

  :first-child {
    padding-left: 0;
  }
`;

export default Modal;